export const ROLE = {
  ADMIN: 'ADMIN',
  SALE_MANAGER: 'SALE MANAGER',
};
